import React, { PureComponent } from 'react';
import { Query } from "react-apollo"
import gql from "graphql-tag"

import getGraphqlURI from 'utils/getGraphqlURI'
import RefetchOnLocaleChange from 'utils/RefetchOnLocaleChange'

export default (getLocale = props => props.match.params.language) => WrappedComponent => class WithSiteMeta extends PureComponent {
  render() {
    const locale = getLocale(this.props)

    return (
      <Query
        context={{
          uri: getGraphqlURI(locale)
        }}
        query={gql`
          query {
            optionsTranslations {
              genericLabels {
                readMore
                readLess
                play
                chooseLanguage
              }
              documentLabels {
                documentType
                product
                language
                freeTextSearch
                reset
                search
              }
              documentPlaceholders {
                documentType
                product
                language
                freeTextSearch
              },
              productTypes {
                capacitive
                climate
                management
              },
              pressMaterialLabels {
                category
                product
              }
              pressMaterialPlaceholders {
                category
                product
              },
              pageContent {
                where_to_buy_button
                downloads_button
                locate_a_dealer_button
                share
              },
              advantageIcons{
                ip67
                save_money
                save_energy
                high_pressure
                accurate
                livestock
                easy_mounting
                well_tested
                long_lifetime
                short_circuit
                compatible
                low_maintenance
                better_fcr
                animal_welfare
                increased_production
                smart_adjust
              },
              searchLabels{
                search_button
                search_placeholder
                not_found
                did_you_mean
                sorry_message
                searching_label
                found_label
              },
              results{
                products_button
                technical_button
                locate_a_dealer_button
                head_office
              },
              resultsLabels{
                products_label
                technical_info_label
                pages_label
              },
              footerLabels{
                footer_header
                footer_some
              }
            }
          }`
        }
      >
        {({ loading, error, data, refetch }) => (
          <div>
            {!error &&
              <RefetchOnLocaleChange locale={locale} refetch={refetch}>
                <WrappedComponent
                  {...this.props}
                  translationsLoading={loading}
                  translations={!loading && !error && data.optionsTranslations}
                />
              </RefetchOnLocaleChange>
            }
            {error && <h1>Error: {error.message}</h1>}
          </div>
        )}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/withTranslations.js